<app-dialog-header
  [title]="'Where You\'re Logged In'"
  [subtitle]="'Click \'Log Out\' for any unfamiliar devices.'"
>
</app-dialog-header>
<div class="u-borderBottom-standard u-marginTop-16"></div>
<mat-dialog-content>
  <div class="u-padding-16-0">
    <div fxLayout="row">
      <div
        *ngFor="let column of tableColumns; let index = index"
        [ngClass]="
          !data.tenant.enabled_features.profile ? '' : 'u-paddingRight-16'
        "
        [ngStyle]="{ width: column.width }"
      >
        <ng-container
          i18n="@@settingsView.sessionsDialog.tableHeader"
          >{column.label, select, other {{{ column.label }}}
        }</ng-container>
      </div>
    </div>
  </div>
  <div
    *ngFor="let session of sessions; let index = index"
    class="u-padding-16-0"
  >
    <div fxLayout="row">
      <div
        [ngStyle]="{ width: tableColumns[0].width }"
        [ngClass]="
          !data.tenant.enabled_features.profile ? '' : 'u-paddingRight-16'
        "
      >
        {{ parseSessionLocation(session) }}
      </div>
      <div
        *ngIf="data.tenant.enabled_features.profile"
        [ngStyle]="{ width: tableColumns[1].width }"
        i18n="@@settingsView.sessionsDialog.timeUpdated"
        [ngClass]="
          !data.tenant.enabled_features.profile ? '' : 'u-paddingRight-16'
        "
      >
        {{ session.updated_at | date: 'fullDate' }} at
        {{ session.updated_at | date: 'shortTime' }}
      </div>
      <div
        [ngStyle]="{ width: tableColumns[2].width }"
        class="'u-paddingRight-16'"
      >
        {{ session.user_agent }}
      </div>
      <div
        [ngStyle]="{ width: tableColumns[3].width }"
        class="u-paddingRight-16"
        fxLayout="row"
        fxLayoutAlign="center center"
      >
        <div>
          <button
            i18n="@@settingsView.sessionsDialog.logout"
            mat-raised-button
            [disabled]="session.isLoading"
            (click)="deleteSessions(session._id)"
            color="primary"
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<div class="u-borderBottom-standard"></div>
<mat-dialog-actions>
  <div fxLayout="row" class="u-width-100" fxLayoutAlign="end center">
    <button i18n="@@global.dismiss" mat-button (click)="close()">
      Dismiss
    </button>
  </div>
</mat-dialog-actions>
